import { render } from "./BatchProcessModal.vue?vue&type=template&id=fb271548&scoped=true"
import script from "./BatchProcessModal.vue?vue&type=script&lang=js"
export * from "./BatchProcessModal.vue?vue&type=script&lang=js"

import "./BatchProcessModal.vue?vue&type=style&index=0&id=fb271548&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb271548"]])

export default __exports__